import { createAction, props } from '@ngrx/store';
import { ReturnStockStatusListState } from '../reducers';

export const LoadReturnStockStatusList = createAction(
  '[Return Stock Status] Load Return Stock status List',
  props<{ returnStockStatusListData: ReturnStockStatusListState }>()
);
